import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_learning/discover/(deprecated)/grundlagenkurs-digitalisierung',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/discover/course-generic/$courseSlug',
      params: {
        courseSlug: 'digital-transformation',
      },
    })
  },
})
